import { useMutation, useQueryClient } from "@tanstack/react-query";
import FETCHER from "./_fetcher";
import { ILogin } from "types/auth";
import { identifyUser } from "../utils/analytics";

export const login = async ({ email, password }: ILogin) => {
  const result = await FETCHER.post(`/auth/login`, {
    email: email.toLocaleLowerCase(),
    password,
  });
  return result;
};

export const useLogin = () => {
  const queryClient = useQueryClient();

  const { data, mutateAsync, isPending } = useMutation({
    mutationFn: login,
    onSuccess: (response) => {
      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: ["getProductById"],
        });

        queryClient.invalidateQueries({
          queryKey: ["getCategory"],
        });
        queryClient.invalidateQueries({
          queryKey: ["getBannerList"],
        });
      }, 300);

      // Identify user with Mixpanel when they successfully log in

      if (response?.data?.email) {
        // Identify user with Mixpanel
        identifyUser(response.data.email, {
          userId: response.data.id,
          name: response.data.name,
          lastLogin: new Date().toISOString(),
        });
      }
    },
  });
  return {
    data: data,
    loginAsync: mutateAsync,
    isPending,
  };
};

export const getNewAccessToken = async (refreshToken: string) => {
  const result = await FETCHER.post(`/auth/refresh`, {
    refreshToken,
  });
  return result;
};
